import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  Paper,
  Alert,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { styled } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

import { LIST_POST } from "../config/const";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface GetXLSXFollowCallModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    follow_call_status: number[];
    all_follow_call_status: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    follow_call_start_year: string;
    follow_call_start_month: string;
    follow_call_end_year: string;
    follow_call_end_month: string;
    follow_call_all_year: boolean;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    follow_call_status: number[];
    all_follow_call_status: boolean;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_id: number | null;
    product_name: string;
    all_product: boolean;
    follow_call_start_year: string;
    follow_call_start_month: string;
    follow_call_end_year: string;
    follow_call_end_month: string;
    follow_call_all_year: boolean;
  }) => void;
  getXLSXFunc: () => void;
  firstYear: number;
  thisYear: number;
  thisMonth: number;
  lastYear: number;
  lastMonth: number;
  companyList: { id: number; sale_company_name: string }[];
  productList: {
    id: number;
    high_rank_company_id: number;
    product_name: string;
    high_rank_company_name: string;
  }[];
}

export function GetXLSXFollowCallModal(props: GetXLSXFollowCallModalProps) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    firstYear,
    thisYear,
    thisMonth,
    lastYear,
    lastMonth,
    companyList,
    productList,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);

  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [postCSVProductName, setPostCSVProductName] = useState<string>("");
  const autocompleteProductList: string[] = productList.map((product) => {
    return product.high_rank_company_name === "-"
      ? product.product_name
      : product.high_rank_company_name + "/" + product.product_name;
  });
  useEffect(() => {
    let productID: null | number = null;
    let productName: string = "";
    productList.map((product) => {
      const _postCSVProductName =
        product.high_rank_company_name === "-"
          ? product.product_name
          : product.high_rank_company_name + "/" + product.product_name;
      if (postCSVProductName === _postCSVProductName) {
        productID = product.id;
        productName = product.product_name;
      }
    });
    if (productID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        product_id: productID,
        product_name: productName,
      });
    }
  }, [postCSVProductName]);

  const [postCSVSaleCompanyName, setPostCSVSaleCompanyName] =
    useState<string>("");
  const autocompleteSaleCompanyList: string[] = companyList.map(
    (saleCompany) => {
      return saleCompany.sale_company_name;
    }
  );
  useEffect(() => {
    let saleCompanyID: null | number = null;
    let saleCompanyName: string = "";
    companyList.map((saleCompany) => {
      if (postCSVSaleCompanyName === saleCompany.sale_company_name) {
        saleCompanyID = saleCompany.id;
        saleCompanyName = saleCompany.sale_company_name;
      }
    });
    if (saleCompanyID) {
      setGetXLSXStatus({
        ...getXLSXStatus,
        sale_company_id: saleCompanyID,
        sale_company_name: saleCompanyName,
      });
    }
  }, [postCSVSaleCompanyName]);

  function closeModal() {
    setPostCSVProductName("");
    setPostCSVSaleCompanyName("");
    swCloseModal();
  }
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="follow-call-xlsx-modal">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          フォローコール一覧出力
        </Typography>
        {getXLSXStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Paper elevation={1}>
              <Box sx={{ maxHeight: "calc(70vh - 80px)", overflowY: "auto" }}>
                <Box key={"tossUpStatus"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "585px",
                    }}
                  >
                    ステータス
                  </FormControl>
                  全ステータス
                  <Checkbox
                    checked={getXLSXStatus.all_follow_call_status}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_follow_call_status:
                          !getXLSXStatus.all_follow_call_status,
                      });
                    }}
                  />
                  {getXLSXStatus.all_follow_call_status ? null : (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "30px",
                        width: "calc(100% - 40px)",
                      }}
                    >
                      {LIST_POST.follow_call_status_xlsx.map(
                        (follow_call_status) => {
                          return (
                            <Box
                              className="serch-label"
                              sx={{ marginRight: "25px" }}
                            >
                              <Checkbox
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 16 },
                                  marginTop: "-5px",
                                }}
                                checked={getXLSXStatus.follow_call_status.includes(
                                  follow_call_status.id
                                )}
                                onClick={() => {
                                  let _follow_call_status =
                                    getXLSXStatus.follow_call_status.concat();
                                  if (
                                    getXLSXStatus.follow_call_status.includes(
                                      follow_call_status.id
                                    )
                                  ) {
                                    _follow_call_status =
                                      _follow_call_status.filter(
                                        (_follow_call_status_id) =>
                                          _follow_call_status_id !==
                                          follow_call_status.id
                                      );
                                  } else {
                                    _follow_call_status.push(
                                      follow_call_status.id
                                    );
                                  }
                                  setGetXLSXStatus({
                                    ...getXLSXStatus,
                                    follow_call_status: _follow_call_status,
                                  });
                                }}
                              />
                              {follow_call_status.value}
                            </Box>
                          );
                        }
                      )}
                    </Box>
                  )}
                </Box>
                <Box key={"paymentElsxProduct"} sx={{ margin: "30px 0px" }}>
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "635px",
                    }}
                  >
                    商材
                  </FormControl>
                  全商材
                  <Checkbox
                    checked={getXLSXStatus.all_product}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        all_product: !getXLSXStatus.all_product,
                      });
                    }}
                  />
                  {getXLSXStatus.all_product ? null : (
                    <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                      <Autocomplete
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                        clearIcon={null}
                        options={autocompleteProductList}
                        value={postCSVProductName}
                        onChange={(event: any, newValue: string | null) => {
                          if (newValue) {
                            setPostCSVProductName(newValue);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            value={postCSVProductName}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "16px",
                                height: "32px",
                              },
                            }}
                            {...params}
                          />
                        )}
                      />
                    </FormControl>
                  )}
                </Box>
                {loginUser?.authority !== "パートナー" &&
                loginUser?.authority !== "営業アカウント" ? (
                  <Box
                    key={"paymentElsxSaleCompany"}
                    sx={{ margin: "30px 0px" }}
                  >
                    <FormControl
                      sx={{
                        marginLeft: "30px",
                        marginTop: "10px",
                        width: "585px",
                      }}
                    >
                      パートナー
                    </FormControl>
                    全パートナー
                    <Checkbox
                      checked={getXLSXStatus.all_company}
                      onClick={() => {
                        setGetXLSXStatus({
                          ...getXLSXStatus,
                          all_company: !getXLSXStatus.all_company,
                        });
                      }}
                    />
                    {getXLSXStatus.all_company ? null : (
                      <FormControl sx={{ width: "520px", marginLeft: "230px" }}>
                        <Autocomplete
                          sx={{
                            height: "30px",
                            textAlign: "end",
                          }}
                          clearIcon={null}
                          options={autocompleteSaleCompanyList}
                          value={postCSVSaleCompanyName}
                          onChange={(event: any, newValue: string | null) => {
                            if (newValue) {
                              setPostCSVSaleCompanyName(newValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              value={postCSVSaleCompanyName}
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "16px",
                                  height: "32px",
                                },
                              }}
                              {...params}
                            />
                          )}
                        />
                      </FormControl>
                    )}
                  </Box>
                ) : null}
                <Box
                  key={"follow_call_paymentElsxBoxYear"}
                  sx={{ margin: "30px 0px" }}
                >
                  <FormControl
                    sx={{
                      marginLeft: "30px",
                      marginTop: "10px",
                      width: "600px",
                    }}
                  >
                    架電希望日
                  </FormControl>
                  検索しない
                  <Checkbox
                    checked={getXLSXStatus.follow_call_all_year}
                    onClick={() => {
                      setGetXLSXStatus({
                        ...getXLSXStatus,
                        follow_call_all_year:
                          !getXLSXStatus.follow_call_all_year,
                      });
                    }}
                  />
                </Box>
                {getXLSXStatus.follow_call_all_year ? null : (
                  <Box
                    key={"follow_call_paymentElsxBoxYear2"}
                    sx={{ margin: "15px 0px" }}
                  >
                    <FormControl sx={{ width: "150px", marginLeft: "130px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.follow_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.follow_call_start_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            follow_call_start_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.follow_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.follow_call_start_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            follow_call_start_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "50px", marginLeft: "45px" }}>
                      ~
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        disabled={getXLSXStatus.follow_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.follow_call_end_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            follow_call_end_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "80px", marginLeft: "30px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        disabled={getXLSXStatus.follow_call_all_year}
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.follow_call_end_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            follow_call_end_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>
            </Paper>
            <Box>
              <Button
                data-testid="follow-call-xlsx-export"
                disabled={
                  (loginUser?.authority !== "パートナー" &&
                    loginUser?.authority !== "営業アカウント" &&
                    getXLSXStatus.sale_company_id === null &&
                    !getXLSXStatus.all_company) ||
                  (getXLSXStatus.product_id === null &&
                    !getXLSXStatus.all_product) ||
                  (getXLSXStatus.follow_call_status.length === 0 &&
                    !getXLSXStatus.all_follow_call_status)
                }
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "205px",
                  width: "200px",
                  fontSize: "20px",
                }}
                onClick={() => {
                  getXLSXFunc();
                  setGetXLSXStatus({
                    ...getXLSXStatus,
                    status: "loading",
                  });
                }}
              >
                <Box className="m-plus-rounded-1c-modal">一覧出力</Box>
                <FileDownloadIcon
                  sx={{ marginLeft: "6px" }}
                  fontSize="medium"
                />
              </Button>
              <Button
                data-testid="follow-call-xlsx-cancel"
                variant="outlined"
                style={{
                  marginTop: "15px",
                  height: "40px",
                  position: "absolute",
                  right: "35px",
                  width: "160px",
                  fontSize: "20px",
                }}
                onClick={closeModal}
              >
                <Box className="m-plus-rounded-1c-modal">キャンセル</Box>
              </Button>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "loading" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>フォローコール一覧作成準備中</Box>
          </Typography>
        ) : getXLSXStatus.status === "getting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
          </Typography>
        ) : getXLSXStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Alert severity="error">
              <Box>フォローコール一覧出力に失敗しました。</Box>
            </Alert>
            <Button
              data-testid="follow-call-xlsx-error-back"
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={() =>
                setGetXLSXStatus({
                  status: "open",
                  message: "",
                  follow_call_status: [],
                  all_follow_call_status: false,
                  sale_company_id: null,
                  sale_company_name: "",
                  all_company: false,
                  product_id: null,
                  product_name: "",
                  all_product: false,
                  follow_call_start_year: lastYear.toString(),
                  follow_call_start_month: lastMonth.toString(),
                  follow_call_end_year: thisYear.toString(),
                  follow_call_end_month: thisMonth.toString(),
                  follow_call_all_year: false,
                })
              }
            >
              戻る
            </Button>
          </Typography>
        ) : getXLSXStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
            <Box>{getXLSXStatus.message}</Box>
            <Button
              data-testid="follow-call-xlsx-result-close"
              variant="outlined"
              style={{
                marginTop: "15px",
                height: "40px",
                position: "absolute",
                right: "45px",
                width: "160px",
                fontSize: "20px",
              }}
              onClick={closeModal}
            >
              閉じる
            </Button>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
}
